import React from 'react';
import { Routes, Route } from "react-router-dom";
import Home from '../Home/Home';
import HomeAR from '../Home/HomeAR';
import Authentication from '../Authentication/Authentication'
import AuthenticationAR from '../Authentication/AuthenticationAR'
import Contact from '../Contact/Contact';
import ContactAR from '../Contact/ContactAR';
import Cart from '../Cart/Cart';
import CartAr from '../Cart/CartAr';
import HomeBody from '../Home/HomeBody';
import HomeBodyAR from '../Home/HomeBodyAR';
import Shop from '../Shop/Shop';
import ShopAR from '../Shop/ShopAR';
import Checkout from '../Checkout/Checkout';
import CheckoutAR from '../Checkout/CheckoutAR';
import WishList from '../WishList/WishList';
import WishListAR from '../WishList/WishListAR';
import Account from '../Account/Account';
import AccountAR from '../Account/AccountAR';
import Confirm from '../Authentication/EmailConfirmation/Confirm';
import ConfirmAR from '../Authentication/EmailConfirmation/ConfirmAR';
import ResetPass from '../Authentication/ResetPassword/ResetPass';
import ResetPassAR from '../Authentication/ResetPassword/ResetPassAR';
import ForgetPass from '../Authentication/ForgetPassword/ForgetPass';
import ForgetPassAR from '../Authentication/ForgetPassword/ForgetPassAR';
import SingleProduct from '../SingleProduct/SingleProduct';
import SingleProductAR from '../SingleProduct/SingleProductAR';
import ListProduct from '../Products/ListProduct';
import ListProductAR from '../Products/ListProductAR';
import SearchedProduct from '../Products/SearchedProduct';
import SearchedProductAR from '../Products/SearchedProductAR';

const AppRoute = (props) => {


  return (
    <>

      <Routes>

        <Route path="/" element={<Home />}>
          <Route index element={<HomeBody />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/Account" element={<Account />} />
          <Route path="/Cart" element={<Cart />} />
          <Route path="/Shop" element={<Shop />} />
          <Route path="/Category/:CategoryName/:CategoryId" element={<ListProduct />}></Route>
          <Route path="/DetailedProduct/:ProductName/:ProductId/:ProductVariationId" element={<SingleProduct />}></Route>
          <Route path="/Product/:Term" element={<SearchedProduct />}></Route>
          
          <Route path="/Checkout" element={<Checkout />} />
          <Route path="/Wishlist" element={<WishList />} />
          <Route path="/Authentication" element={<Authentication setSubscribe={props.setSubscribe} />} />
          <Route path="/Email-Confirmation" element={<Confirm />} />
          <Route path="/Reset-Password" element={<ResetPass />} />
          <Route path="/Forget-Password" element={<ForgetPass />} />
        </Route>

        <Route path="/AR" element={<HomeAR />}>
          <Route index element={<HomeBodyAR />} ></Route>

          <Route path="Contact" element={<ContactAR />} ></Route>
          <Route path="Account" element={<AccountAR />} ></Route>
          <Route path="Cart" element={<CartAr />} ></Route>
          <Route path="Shop" element={<ShopAR />} />
          <Route path="Category/:CategoryName/:CategoryId" element={<ListProductAR />}></Route>

          <Route path="DetailedProduct/:ProductName/:ProductId/:ProductVariationId" element={<SingleProductAR />}></Route>
          <Route path="Product/:Term" element={<SearchedProductAR />}></Route>

          <Route path="Wishlist" element={<WishListAR />} />
          <Route path="Checkout" element={<CheckoutAR />} />

          <Route path="Authentication" element={<AuthenticationAR setSubscribe={props.setSubscribe} />} ></Route>
          <Route path="Email-Confirmation" element={<ConfirmAR />} ></Route>
          <Route path="Reset-Password" element={<ResetPassAR />} ></Route>
          <Route path="Forget-Password" element={<ForgetPassAR />} />


        </Route>
        {/* <Route path="/AR" element={<HomeAR />} />
        <Route path="/AR/Contact" element={<ContactAR />} ></Route> */}

      </Routes>

    </>
  )
}

export default AppRoute